<div
  role="status"
  class="flex items-center gap-16 rounded-[8px] bg-[#1d273c] py-[10px] pl-16 pr-8 text-[13px] leading-[21px] text-white shadow-[0_6px_16px_0_rgba(0,0,0,0.08),0_3px_6px_-4px_rgba(0,0,0,0.12),0_9px_28px_8px_rgba(0,0,0,0.05)]"
  (mouseenter)="pause()"
  (mouseleave)="resume()"
>
  <p class="m-0 w-[360px]">
    <span class="font-semibold">{{ config.message }}</span>
    @if (config.explanation) {
      {{ config.explanation }}
    }
  </p>
  @for (action of config.actions ?? []; track action.label) {
    <button
      type="button"
      class="cursor-pointer whitespace-nowrap border-0 bg-transparent p-0 font-semibold text-[#8fb3fe]"
      (click)="runAction(action)"
    >
      {{ action.label }}
    </button>
  }
  <button
    type="button"
    aria-label="Close"
    class="flex h-[22px] w-[22px] cursor-pointer items-center justify-center border-0 bg-transparent p-0"
    (click)="close()"
  >
    <twaice-fe-svg-icon name="x" source="tabler" size="16px" color="white" />
  </button>
</div>
